import HTTP from "../http";
import Jsona from "jsona";
import moment from "moment-business-days";
import { captureException, addBreadcrumb } from "@sentry/browser";

const dataFormatter = new Jsona();

export default {
  async getPayment(payment_id) {
    try {
      let payment = await HTTP.normal.get(
        `/payments/${payment_id}?include=funding_instrument`
      );
      return dataFormatter.deserialize(payment.data);
    } catch (e) {
      throw e.response.data;
    }
  },

  async paymentViaBoleto(payload) {
    try {
      let expiration_date = moment(payload.data.starts_at).businessSubtract(3);

      if (
        payload.data.type == "cycle" &&
        payload.data.subscription.payment_emission_day != 28
      )
        expiration_date = moment(payload.data.starts_at).set({
          date: payload.data.subscription.payment_emission_day
        });

      if (payload.data.type == "order" || expiration_date < moment())
        expiration_date = moment().businessAdd(1);

      let data = {
        data: {
          type: "payments",
          relationships: {
            payable: {
              data: {
                id: payload.data.id,
                type: payload.data.type
              }
            },
            funding_instrument: {
              attributes: {
                expiration_date
              }
            }
          }
        },
        meta: {
          consume_account_balance: payload.accountBalance,
          consume_account_bonus_balance: payload.accountBonus
        }
      };

      let boleto = await HTTP.normal.post(`/payments/boleto`, data);
      return dataFormatter.deserialize(boleto.data);
    } catch (e) {
      captureException(e);
      throw e.response.data;
    }
  },

  async paymentViaCreditCard(payload) {
    try {
      let data = payload.data;
      let payable = payload.payable;

      let cc = PagSeguro.encryptCard({
        holder: data.name,
        number: data.number,
        securityCode: data.cvc,
        expMonth: data.deadline_month,
        expYear: data.deadline_year,
        publicKey: process.env.PAGBANK_PUB_KEY
      });

      if (cc.hasErrors) throw "Cartão Inválido!";

      let document_type = data.document.length > 11 ? "CNPJ" : "CPF";

      let body = {
        data: {
          type: "payments",
          relationships: {
            payable: {
              data: {
                type: payable.type === "orders" ? "order" : "cycle",
                id: payable.id
              }
            },
            funding_instrument: {
              data: {
                type: "credit_card"
              },
              attributes: {
                store: data.store || false,
                hash: cc.encryptedCard,
                holder: {
                  phone: data.phone,
                  address: {
                    street: payable.address.street,
                    street_number: payable.address.street_number,
                    zip_code: payable.address.zip_code,
                    complement: payable.address.complement || "",
                    district: payable.address.district.display_name,
                    city: payable.address.district.city.display_name,
                    state: payable.address.district.city.state.code,
                    country: payable.address.district.city.state.country.code
                  },
                  full_name: data.name,
                  birthdate: data.birthdate,
                  document_type,
                  document_number: data.document
                }
              }
            }
          }
        },
        meta: {
          consume_account_balance: payload.accountBalance,
          consume_account_bonus_balance: payload.accountBonus
        }
      };

      let res = await HTTP.normal.post(`/payments/credit-card/new`, body);
      return dataFormatter.deserialize(res.data);
    } catch (e) {
      addBreadcrumb({
        data: { body, response: JSON.stringify(e.response.data) }
      });
      captureException(e);
      throw e;
    }
  },

  async paymentViaStoredCreditCard({
    data,
    payable,
    accountBalance,
    accountBonus
  }) {
    try {
      const body = {
        data: {
          type: "payments",
          relationships: {
            payable: {
              data: {
                type: payable.type === "orders" ? "order" : "cycle",
                id: payable.id
              }
            },
            funding_instrument: {
              data: {
                type: "credit_card",
                id: data.selectedCard
              },
              attributes: {
                cvc: data.cvv
              }
            }
          }
        },
        meta: {
          consume_account_balance: accountBalance,
          consume_account_bonus_balance: accountBonus
        }
      };

      const res = await HTTP.normal.post(`/payments/credit-card/stored`, body);
      return dataFormatter.deserialize(res.data);
    } catch (e) {
      captureException(e);
      throw e;
    }
  },

  async confirmOrderWithAccountBalance(id) {
    let data = {
      data: {
        type: "payments",
        relationships: {
          payable: {
            data: {
              id: id,
              type: "order"
            }
          }
        }
      }
    };

    let response = await HTTP.normal.post(`/payments/account-balance`, data);
    return dataFormatter.deserialize(response.data);
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/payments.js